import { UserInfo, MessagesToUserInfo, SurveyManagerAccessInfoData, 
  SupportEmailAddressData, AdminInfoData, ToolsInfoData, 
  InstanceInfo,
  AiChatAssistantAccessInfo} from 'app/types-shared';
import { Consent } from 'app/area/user-profile/my-notifications/types';

export const ACTION = {
  RequestUserInfo: 'SHELL:REQUEST_USER_INFO',
  ReceiveUserInfo: 'SHELL:RECEIVE_USER_INFO',
  ReceiveShellConfig: 'SHELL:RECEIVE_SHELL_CONFIG',
  FailUserInfo: 'SHELL:FAIL_USER_INFO',
  ReceiveToken: 'SHELL:RECEIVE_TOKEN',
  ReceiveLogout: 'SHELL:RECEIVE_LOGOUT',
  AuthenticationFailed: 'SHELL:AUTHENTICATION_FAILED',
  DisplayModal: 'SHELL:DISPLAY_MODAL',
  ChangeUserLocale: 'SHELL:CHANGE_USER_LOCALE',
  RefreshCache: 'SHELL:REFRESH_CACHE',
  ReceiveRefreshCache: 'SHELL:RECEIVE_REFRESH_CACHE',
  FailRefreshCache: 'SHELL:FAIL_REFRESH_CACHE',
  RegenerateAggregatedEnv: 'SHEll:REGENERATE_AGGREGATED_ENV',
  RegenerateAggregatedRisk: 'SHEll:REGENERATE_AGGREGATED_RISK',
  RegenerateAggregatedTables: 'SHEll:REGENERATE_AGGREGATED_TABLES',
  RequestMessagesToUserInfo: 'SHELL:REQUEST_MESSAGES_TO_USER',
  ReceiveMessagesToUserInfo: 'SHELL:RECEIVE_MESSAGES_TO_USER',
  UpdateMessageStatus: 'SHELL:MESSAGES_TO_USER_UPDATE_MESSAGE_STATUS',
  FixedHeaderStatus: 'SHELL:FIXED_HEADER_STATUS',
  REQUEST_LOAD_CONSENTS: 'NOTIFICATION_PANEL:REQUEST_LOAD_CONSENTS',
  RECEIVE_LOAD_CONSENTS: 'NOTIFICATION_PANEL:RECEIVE_LOAD_CONSENTS',
  FAIL_LOAD_CONSENTS: 'NOTIFICATION_PANEL:FAIL_LOAD_CONSENTS'
};

export class UserLocaleChange {
  public type: string = ACTION.ChangeUserLocale;
  public locale: string;
  constructor(locale: string) {
    this.locale = locale;
  }
}

export class ReceiveShellConfig {
  public type: string = ACTION.ReceiveShellConfig;

  constructor(
    public version?: string,
    public supportEmailAddress?: SupportEmailAddressData,
    public adminPanelAccess?: AdminInfoData | boolean,
    public toolsInfo?: ToolsInfoData,
    public surveyManagerAccess?: SurveyManagerAccessInfoData,
    public helpUrl?: string,
    public manageSurveysUrl?: string,
    public feedbackUrl?: string,
    public instanceInfo?: InstanceInfo,
    public aiChatAssistantAccessInfo?: AiChatAssistantAccessInfo
  ) { }
}

export class ReceiveUserInfo {
  public type: string = ACTION.ReceiveUserInfo;

  constructor(public userInfo: UserInfo) { }
}

export class RequestUserInfo {
  public type: string = ACTION.RequestUserInfo;
}

export class FailUserInfo {
  public type: string = ACTION.FailUserInfo;
}

export class ReceiveToken {
  public type: string = ACTION.ReceiveToken;
}

export class ReceiveLogout {
  public type: string = ACTION.ReceiveLogout;
}

export class AuthenticationFailed {
  public type: string = ACTION.AuthenticationFailed;
}

export class DisplayModal {
  public type: string = ACTION.DisplayModal;
  public name: string;
  public endpoint?: string;
  public description?: string;

  constructor(name: string, endpoint?: string, description?: string) {
    this.name = name;
    this.endpoint = endpoint;
    this.description = description;
  }
}

export class RefreshCache {
  public type: string = ACTION.RefreshCache;
  public fetching: boolean = true;
}

export class ReceiveRefreshCache {
  public type: string = ACTION.ReceiveRefreshCache;
}

export class FailRefreshCache {
  public type: string = ACTION.FailRefreshCache;
}

export class RegenerateAggregatedEnv {
  public type: string = ACTION.RegenerateAggregatedEnv;
  constructor(public fetching: boolean) { }
}

export class RegenerateAggregatedRisk {
  public type: string = ACTION.RegenerateAggregatedRisk;
  constructor(public fetching: boolean) { }
}

export class RegenerateAggregatedTables {
  public type: string = ACTION.RegenerateAggregatedTables;
  constructor(public fetching: boolean) { }
}

export class RequestMessagesToUserInfo {
  public type: string = ACTION.RequestMessagesToUserInfo;
}

export class ReceiveMessagesToUserInfo {
  public type: string = ACTION.ReceiveMessagesToUserInfo;
  public messagesToUserInfo: MessagesToUserInfo[];

  constructor(messagesToUserInfo: MessagesToUserInfo[]) {
    this.messagesToUserInfo = messagesToUserInfo;
  }
}
export class UpdateMessageStatus {
  public type: string = ACTION.UpdateMessageStatus;
  constructor(public updating: boolean, public id?: number) { }
}

export class FixedHeaderStatus {
  public type: string = ACTION.FixedHeaderStatus;
  constructor(public fixed: boolean) { }
}

export class RequestLoadConsents {
  public type: string = ACTION.REQUEST_LOAD_CONSENTS;
}

export class ReceiveLoadConsents {
  public type: string = ACTION.RECEIVE_LOAD_CONSENTS;
  constructor(public consents: Consent[]) { }
}

export class FailLoadConsents {
  public type: string = ACTION.FAIL_LOAD_CONSENTS;
}
